import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const snakeToCamel = (str) =>
  str.replace(/([-_]\w)/g, (g) => g[1].toUpperCase())

export default new Vuex.Store({
  state: {
    /** config */
    config: {
      domainUltimaFarm: '',
      domainUltimaRest: '',
    },

    /** profile */
    profile: {
      allowPublicProfile: null,
      avatar: null,
      comment: null,
      firstName: null,
      instagram: null,
      inviteCode: null,
      lastName: null,
      mobile: null,
      position: null,
      skype: null,
      telegram: null,
      userId: null,
      viber: null,
      wechat: null,
      whatsapp: null,
    },
  },
  mutations: {
    /** config */
    setConfig(state, value) {
      Object.keys(value).forEach((key) => {
        state.config[snakeToCamel(key)] = value[key]
      })
    },

    /** profile */
    setProfile(state, value) {
      state.profile = { ...state.profile, ...value}
    },
  },
  getters: {
    /** config */
    getConfig: state => state.config,

    /** profile */
    getProfile: state => state.profile,
  }
})
